
import { FileText, Briefcase, File, Search, Shield, CreditCard, Users, Settings } from "lucide-react";
import { Link } from "react-router-dom";
import {
  NavigationMenu,
  NavigationMenuContent,
  NavigationMenuItem,
  NavigationMenuLink,
  NavigationMenuList,
  NavigationMenuTrigger,
} from "@/components/ui/navigation-menu";

const ExpertiseMenu = () => {
  return (
    <NavigationMenu>
      <NavigationMenuList>
        <NavigationMenuItem>
          <NavigationMenuTrigger className="text-white/80 hover:text-white bg-transparent hover:bg-transparent px-0 text-base">
            Expertise
          </NavigationMenuTrigger>
          <NavigationMenuContent className="bg-background/95 backdrop-blur-lg border border-white/10">
            <ul className="grid gap-3 p-4 md:w-[500px] grid-cols-2">
              <li>
                <NavigationMenuLink asChild>
                  <Link
                    to="/expertise/contract-lifecycle"
                    className="block select-none space-y-1 rounded-md p-3 leading-none no-underline outline-none transition-colors hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground"
                  >
                    <div className="flex items-center gap-2">
                      <FileText className="h-4 w-4 text-blue-400" />
                      <div className="text-sm font-medium leading-none text-white">Contract Lifecycle Management</div>
                    </div>
                    <p className="line-clamp-2 text-sm leading-snug text-white/70">
                      End-to-end contract management solutions
                    </p>
                  </Link>
                </NavigationMenuLink>
              </li>
              <li>
                <NavigationMenuLink asChild>
                  <Link
                    to="/expertise/case-management"
                    className="block select-none space-y-1 rounded-md p-3 leading-none no-underline outline-none transition-colors hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground"
                  >
                    <div className="flex items-center gap-2">
                      <Briefcase className="h-4 w-4 text-purple-400" />
                      <div className="text-sm font-medium leading-none text-white">Case Management</div>
                    </div>
                    <p className="line-clamp-2 text-sm leading-snug text-white/70">
                      Streamlined organization of legal cases
                    </p>
                  </Link>
                </NavigationMenuLink>
              </li>
              <li>
                <NavigationMenuLink asChild>
                  <Link
                    to="/expertise/document-analysis"
                    className="block select-none space-y-1 rounded-md p-3 leading-none no-underline outline-none transition-colors hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground"
                  >
                    <div className="flex items-center gap-2">
                      <File className="h-4 w-4 text-green-400" />
                      <div className="text-sm font-medium leading-none text-white">Document Analysis & Drafting</div>
                    </div>
                    <p className="line-clamp-2 text-sm leading-snug text-white/70">
                      AI-powered document review and creation
                    </p>
                  </Link>
                </NavigationMenuLink>
              </li>
              <li>
                <NavigationMenuLink asChild>
                  <Link
                    to="/expertise/litigation"
                    className="block select-none space-y-1 rounded-md p-3 leading-none no-underline outline-none transition-colors hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground"
                  >
                    <div className="flex items-center gap-2">
                      <Search className="h-4 w-4 text-amber-400" />
                      <div className="text-sm font-medium leading-none text-white">Litigation & Research</div>
                    </div>
                    <p className="line-clamp-2 text-sm leading-snug text-white/70">
                      Enhanced discovery and legal research tools
                    </p>
                  </Link>
                </NavigationMenuLink>
              </li>
              <li>
                <NavigationMenuLink asChild>
                  <Link
                    to="/expertise/compliance"
                    className="block select-none space-y-1 rounded-md p-3 leading-none no-underline outline-none transition-colors hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground"
                  >
                    <div className="flex items-center gap-2">
                      <Shield className="h-4 w-4 text-red-400" />
                      <div className="text-sm font-medium leading-none text-white">Regulatory Compliance</div>
                    </div>
                    <p className="line-clamp-2 text-sm leading-snug text-white/70">
                      Automated contract and regulation compliance
                    </p>
                  </Link>
                </NavigationMenuLink>
              </li>
              <li>
                <NavigationMenuLink asChild>
                  <Link
                    to="/expertise/transactions"
                    className="block select-none space-y-1 rounded-md p-3 leading-none no-underline outline-none transition-colors hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground"
                  >
                    <div className="flex items-center gap-2">
                      <CreditCard className="h-4 w-4 text-indigo-400" />
                      <div className="text-sm font-medium leading-none text-white">Commercial Transactions</div>
                    </div>
                    <p className="line-clamp-2 text-sm leading-snug text-white/70">
                      Optimized commercial transaction processing
                    </p>
                  </Link>
                </NavigationMenuLink>
              </li>
              <li>
                <NavigationMenuLink asChild>
                  <Link
                    to="/expertise/client-management"
                    className="block select-none space-y-1 rounded-md p-3 leading-none no-underline outline-none transition-colors hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground"
                  >
                    <div className="flex items-center gap-2">
                      <Users className="h-4 w-4 text-cyan-400" />
                      <div className="text-sm font-medium leading-none text-white">Client Relationship Management</div>
                    </div>
                    <p className="line-clamp-2 text-sm leading-snug text-white/70">
                      Enhanced client communication and management
                    </p>
                  </Link>
                </NavigationMenuLink>
              </li>
              <li>
                <NavigationMenuLink asChild>
                  <Link
                    to="/expertise/practice-management"
                    className="block select-none space-y-1 rounded-md p-3 leading-none no-underline outline-none transition-colors hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground"
                  >
                    <div className="flex items-center gap-2">
                      <Settings className="h-4 w-4 text-orange-400" />
                      <div className="text-sm font-medium leading-none text-white">Practice Management</div>
                    </div>
                    <p className="line-clamp-2 text-sm leading-snug text-white/70">
                      Comprehensive law practice management platforms
                    </p>
                  </Link>
                </NavigationMenuLink>
              </li>
            </ul>
          </NavigationMenuContent>
        </NavigationMenuItem>
      </NavigationMenuList>
    </NavigationMenu>
  );
};

export default ExpertiseMenu;
